import { useMemo } from "react";
import { useGlobalSetting } from "Store/GlobalSettingStore";
import { AppLeftBarItem } from "./AppLeftBarMenuItems";
import { useRootStore } from "Store/RootStore";

export const usePinnedItems = () => {
    const settingStore = useGlobalSetting("appHubApp");
    const appStore = useRootStore("AppSettingStore");

    const pinnedApps = useMemo(() => {
        const apps: AppLeftBarItem[] = [];
        settingStore.allPinnedApps.forEach((id) => {
            const matchedApp = appStore.appModels.find((app) => app.id === id);
            if (matchedApp) {
                apps.push({
                    displayName: matchedApp.title,
                    routeName: matchedApp.path,
                    regularIcon: matchedApp.regularIcon,
                    filledIcon: matchedApp.filledIcon
                });
            }
        });
        return apps;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingStore.allPinnedApps.length, appStore.appModels]);

    return pinnedApps;
};
